<template>
  <ion-page>
    <!--content start -->
    <ion-content>
      <div class="order-status">
        <div align="center" class="mb-img">
          <img src="assets/images/order-complete.png" />
        </div>
        <div class="orderstatus-div">
          <ion-row class="row-orderlist">
            <ion-col size="12">
              <span class="txtlight-sml">
                Order # {{ orderId.replace(/-/gi, "").toUpperCase() }}
              </span>
            </ion-col>
            <ion-col size="12">
              <span class="orderstatus-h1">We have received your order</span>
            </ion-col>
          </ion-row>
          <div>
            <ion-row class="row-orderlist">
              <!--<ion-col size="2">
                <span class="orderstatus-cancel">Cancel</span>
              </ion-col>-->
              <ion-col>
                <ion-icon
                  src="assets/icon/dot-separate.svg"
                  class="dotsep-icon"
                  color="primary"
                >
                </ion-icon>
                <ion-icon
                  src="assets/icon/notification-circle.svg"
                  class="notify-icon"
                >
                </ion-icon>
                <span class="orderstatus-notify">
                  Notifying your barista...
                </span>
              </ion-col>
            </ion-row>
          </div>
          <div>
            <ion-row class="row-orderlist">
              <ion-col>
                <span class="order-status-txtlight">Ready in</span>
              </ion-col>
              <ion-col>
                <span class="order-status-txtlight position-right">Time</span>
              </ion-col>
            </ion-row>
            <ion-row class="row-orderlist">
              <ion-col>
                <span class="order-status-bold">5 - 10mins</span>
              </ion-col>
              <ion-col>
                <span class="order-status-bold position-right">
                  {{ timePlus5Minutes }} - {{ timePlus10Minutes }}
                </span>
              </ion-col>
            </ion-row>
          </div>
        </div>

        <div class="orderstatus-div ion-margin-top">
          <ion-row
            class="row-orderlist"
            v-for="orders in cartOrders"
            :key="orders.id"
          >
            <ion-col size="2">
              <span class="order-status-bold">{{ orders.quantity }} x</span>
            </ion-col>
            <ion-col>
              <span class="order-status-bold">
                {{ orders.product.productName }}
              </span>
              <div v-for="(variations, key) in orders.variations" :key="key">
                <span
                  class="order-status-txtlight dblock"
                  v-if="variations !== null"
                >
                  <span v-if="variations.category" class="variation-category">
                    {{ variations.category }}:
                  </span>
                  <span class="variation-value">{{ variations.name }}</span>
                  <span
                    v-if="
                      (variations.name.includes('Sugar') ||
                        variations.name.includes('Sweetener')) &&
                      !variations.name.includes('No Sugar') &&
                      variations.quantity > 0
                    "
                  >
                    x {{ variations.quantity }}
                  </span>
                </span>
              </div>
              <div v-if="orders.instructions !== ''">
                <span class="order-status-bold">
                  Special Instructions: <br />
                </span>
                <span class="order-status-txtlight dblock">
                  {{ orders.instructions }}
                </span>
              </div>
            </ion-col>
            <ion-col>
              <span class="order-status-normal position-right">
                $ {{ parseFloat(orders.pricePerOrder || 0).toFixed(2) }}
              </span>
            </ion-col>
          </ion-row>
          <ion-row class="row-orderlist hr-subtotal">
            <ion-col>
              <span class="order-status-normal">
                SubTotal ({{ totalCartQty }} item/s)
              </span>
            </ion-col>
            <ion-col>
              <span class="order-status-normal position-right">
                $ {{ (subTotalCartPrice || 0).toFixed(2) }}
              </span>
            </ion-col>
          </ion-row>
          <ion-row class="row-orderlist hr-subtotal">
            <ion-col>
              <span class="order-status-normal">Discount</span>
            </ion-col>
            <ion-col>
              <span class="order-status-normal position-right">
                - $ {{ (discountPrice || 0).toFixed(2) }}
              </span>
            </ion-col>
          </ion-row>
          <ion-row class="row-orderlist">
            <ion-col>
              <span class="order-status-normal">Service Fee</span>
            </ion-col>
            <ion-col>
              <span class="order-status-normal position-right">
                $ {{ (serviceFee || 0).toFixed(2) }}
              </span>
            </ion-col>
          </ion-row>
          <ion-row class="row-orderlist">
            <ion-col><span class="order-status-bold">Total</span> </ion-col>
            <ion-col>
              <span class="order-status-bold position-right">
                $ {{ (totalCartPrice || 0).toFixed(2) }}
              </span>
            </ion-col>
          </ion-row>
        </div>

        <iframe
          class="orderstatus-maps"
          width="100%"
          height="100%"
          :src="
            'https://www.google.com/maps?&q=' + cafeAddress + '&output=embed'
          "
          style="border: 0"
          allowfullscreen=""
          loading="lazy"
          referrerpolicy="no-referrer-when-downgrade"
        >
        </iframe>
        <ion-row>
          <ion-col size="12">
            <span class="order-status-bold">
              {{ cafeName }}
            </span>
          </ion-col>
          <ion-col size="12">
            <span class="order-status-txtlight">
              {{ cafeAddress }}
            </span>
          </ion-col>
        </ion-row>
        <!-- Track Your Order button -->
        <a href="/order-history">
          <ion-button expand="block" color="primary" class="orderstatus-btn">
            Track Your Order
          </ion-button>
        </a>
        <div align="center" class="ion-margin-top">
          <span class="support-link">
            <router-link to="/support"> Contact Support </router-link>
          </span>
        </div>
      </div>
    </ion-content>
    <!-- content end -->
  </ion-page>
</template>
<script>
import { defineComponent, ref, onMounted } from "vue";
import axios from "axios";
import {
  IonPage,
  IonContent,
  IonRow,
  IonCol,
  IonIcon,
  IonButton,
  alertController,
} from "@ionic/vue";

const BASE_URI =
  process.env.VUE_APP_BASE_URI !== undefined
    ? process.env.VUE_APP_BASE_URI
    : "https://api.onecoffeeapp.com.au";

export default defineComponent({
  name: "OrderStatusPage",
  components: { IonPage, IonContent, IonRow, IonCol, IonIcon, IonButton },
  data() {
    return {
      cartOrders: [],
      totalCartQty: 0,
      subTotalCartPrice: 0,
      serviceFee: 0,
      totalCartPrice: 0,
      cafeId: "",
      cafeName: "",
      cafeAddress: "",
      orders: [],
      order: null, // Single order for reactive updates
      orderId: "",
      promptMessage: "",
      discountPrice: 0,
      orderPollTimeoutId: null, // Track timeout for cleanup
    };
  },
  beforeUnmount() {
    // Clean up polling timeout when component unmounts
    if (this.orderPollTimeoutId) {
      clearTimeout(this.orderPollTimeoutId);
      this.orderPollTimeoutId = null;
    }
  },
  setup() {
    const currentTime = ref("");
    const timePlus5Minutes = ref("");
    const timePlus10Minutes = ref("");

    // Function to get the current time and the two adjusted times (without seconds)
    const updateTime = () => {
      const now = new Date();

      // Update current time, without seconds
      currentTime.value = now.toLocaleTimeString([], {
        hour: "2-digit",
        minute: "2-digit",
      });

      // Calculate time + 5 minutes, without seconds
      const time5 = new Date(now.getTime() + 5 * 60000);
      timePlus5Minutes.value = time5.toLocaleTimeString([], {
        hour: "2-digit",
        minute: "2-digit",
      });

      // Calculate time + 10 minutes, without seconds
      const time10 = new Date(now.getTime() + 10 * 60000);
      timePlus10Minutes.value = time10.toLocaleTimeString([], {
        hour: "2-digit",
        minute: "2-digit",
      });
    };

    // Only calculate the time once when the component is mounted
    onMounted(() => {
      updateTime(); // Set the time immediately on mount
    });

    return {
      currentTime,
      timePlus5Minutes,
      timePlus10Minutes,
    };
  },
  methods: {
    async presentAlert(status) {
      const alert = await alertController.create({
        message: this.promptMessage,
      });

      await alert.present();
      await alert.onDidDismiss();
      if (status == 200 || status === 400) window.location.href = "/home";
      else return;
    },
    async pollOrderStatus(order_uuid, axiosConfig, pollCount = 0) {
      // Poll for order status changes (pending_payment → received)
      const MAX_POLLS = 60; // 2 minutes at 2 second intervals
      const POLL_INTERVAL = 2000; // 2 seconds

      if (pollCount >= MAX_POLLS) {
        console.error("Payment confirmation timeout");
        this.promptMessage =
          "Payment is taking longer than expected. Please check your order history.";
        this.presentAlert(500);
        return;
      }

      // Clear any existing timeout before creating a new one
      if (this.orderPollTimeoutId) {
        clearTimeout(this.orderPollTimeoutId);
        this.orderPollTimeoutId = null;
      }

      this.orderPollTimeoutId = setTimeout(async () => {
        try {
          const orderResponse = await axios.get(
            `${BASE_URI}/orders/${order_uuid}`,
            axiosConfig
          );

          // Validate response shape before accessing
          if (
            !orderResponse ||
            !orderResponse.data ||
            !orderResponse.data.data ||
            typeof orderResponse.data.data !== "object"
          ) {
            console.error("Invalid order response structure:", orderResponse);
            // Clear timeout and show error
            if (this.orderPollTimeoutId) {
              clearTimeout(this.orderPollTimeoutId);
              this.orderPollTimeoutId = null;
            }
            this.promptMessage =
              "Unable to fetch order status. Please try again.";
            await this.presentAlert(500);
            return;
          }

          const order = orderResponse.data.data;

          if (order && order.status === "received") {
            // Payment confirmed! Navigate to show success
            console.log("Payment confirmed - order status updated to received");
            // Clear timeout and update promptMessage for display
            if (this.orderPollTimeoutId) {
              clearTimeout(this.orderPollTimeoutId);
              this.orderPollTimeoutId = null;
            }
            this.promptMessage = "Order confirmed and received!";
            // Update the order object reactively instead of full page reload
            this.order = order;
          } else {
            // Continue polling - timeout will be cleared at start of next call
            this.pollOrderStatus(order_uuid, axiosConfig, pollCount + 1);
          }
        } catch (error) {
          const status = error.response?.status;

          // Stop polling for fatal errors (non-retryable)
          if (
            status === 401 ||
            status === 403 ||
            status === 404 ||
            status === 410
          ) {
            console.error("Fatal error polling order status:", error);
            if (this.orderPollTimeoutId) {
              clearTimeout(this.orderPollTimeoutId);
              this.orderPollTimeoutId = null;
            }
            this.promptMessage =
              "Order not found. Please check your order history.";
            this.presentAlert(status);
            return;
          }

          // Continue polling for transient network errors (no response or 5xx) - timeout will be cleared at start of next call
          console.error("Error polling order status, retrying:", error);
          this.pollOrderStatus(order_uuid, axiosConfig, pollCount + 1);
        }
      }, POLL_INTERVAL);
    },
    async getCartOrders(userId, cafeId, cartOrderIds) {
      let axiosConfig = {
        headers: {
          Authorization: localStorage.getItem("token"),
          "Content-Type": "application/json;charset=UTF-8",
        },
      };

      let url = userId
        ? BASE_URI +
          "/cart/get-cart-orders/?userId=" +
          userId +
          "&cafeId=" +
          cafeId +
          "&cartOrderIds=[" +
          cartOrderIds +
          "]"
        : BASE_URI + "/cafe/get-coffee-shops";

      let result = await axios
        .get(url, axiosConfig)
        .then((res) => res.data)
        .catch((err) => {
          this.promptMessage = "This order is not available.";
          this.presentAlert(err.response.status);
          throw err.response.status;
        });

      this.cartOrders = result && result.data.length ? await result.data : [];

      for (let i = 0; i < this.cartOrders.length; i++) {
        this.totalCartQty += this.cartOrders[i].quantity;
        this.subTotalCartPrice +=
          parseFloat(this.cartOrders[i].pricePerOrder) || 0;
      }

      // Get cafe info from cart orders if available, otherwise keep empty
      if (this.cartOrders.length > 0 && this.cartOrders[0].cafe) {
        this.cafeId = this.cartOrders[0].cafe.cafeId;
        this.cafeName = this.cartOrders[0].cafe.shopName;
        this.cafeAddress = this.cartOrders[0].cafe.address;
      }
    },
    async getOrders(userId, cafeId, cartOrderIds) {
      let axiosConfig = {
        headers: {
          Authorization: localStorage.getItem("token"),
          "Content-Type": "application/json;charset=UTF-8",
        },
      };

      let url = userId
        ? BASE_URI +
          "/orders/get-orders/?userId=" +
          userId +
          "&status=received" +
          "&cafeId=" +
          cafeId +
          "&cartOrderIds=[" +
          cartOrderIds +
          "]"
        : BASE_URI + "/cafe/get-coffee-shops";

      let result = await axios
        .get(url, axiosConfig)
        .then((res) => res.data)
        .catch((err) => {
          this.promptMessage = "This order is not available anymore.";
          this.presentAlert(err.response.status);
          throw err.response.status;
        });

      this.orders = result && result.data.length ? await result.data : [];

      // Only set these if we have orders in the result
      if (this.orders.length > 0) {
        this.orderId = this.orders[0].uuid;
        this.discountPrice = parseFloat(this.orders[0].discount) || 0;
        this.serviceFee = parseFloat(this.orders[0].serviceFee) || 0;
        this.totalCartPrice = parseFloat(this.orders[0].total) || 0;
      }
    },
  },
  async created() {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const cafeId = urlParams.get("cafeId") || "";
    const order_uuid = urlParams.get("order_uuid");

    // Validate order_uuid is present
    if (!order_uuid) {
      console.error("No order_uuid in URL");
      this.promptMessage =
        "Order not found. Please try placing your order again.";
      await this.presentAlert(400);
      // presentAlert already handles redirect for status 400
      return;
    }

    let axiosConfig = {
      headers: {
        Authorization: localStorage.getItem("token"),
        "Content-Type": "application/json;charset=UTF-8",
      },
    };

    try {
      // Fetch existing order by UUID (pending_payment order already created by checkout)
      const orderResponse = await axios.get(
        `${BASE_URI}/orders/${order_uuid}`,
        axiosConfig
      );

      const order = orderResponse.data.data;

      if (!order) {
        this.promptMessage = "Order not found. Please contact support.";
        this.presentAlert(404);
        return;
      }

      // Set cafe information from order
      if (order.cafeId) {
        this.cafeId = order.cafeId;
      }
      if (order.cafeName) {
        this.cafeName = order.cafeName;
      }
      if (order.cafeAddress) {
        this.cafeAddress = order.cafeAddress;
      }

      // Set order details from the fetched order
      this.orderId = order.uuid;
      this.discountPrice = parseFloat(order.discount) || 0;
      this.serviceFee = parseFloat(order.serviceFee) || 0;
      this.totalCartPrice = parseFloat(order.total) || 0;

      // Check order status and set user-facing messages
      if (order.status === "pending_payment") {
        // Order is awaiting payment confirmation from webhook
        this.promptMessage = "Waiting for payment confirmation...";
        // Start polling for status updates
        this.pollOrderStatus(order_uuid, axiosConfig);
      } else if (order.status === "received") {
        this.promptMessage = "Order received and being prepared";
        console.log("Order placed successfully!");
      } else if (order.status === "completed") {
        this.promptMessage = "Order completed! Enjoy your coffee.";
        // Stop any polling for terminal state
        if (this.orderPollTimeoutId) {
          clearTimeout(this.orderPollTimeoutId);
          this.orderPollTimeoutId = null;
        }
      } else if (order.status === "cancelled") {
        this.promptMessage =
          "Order was cancelled. Please contact support if this was unexpected.";
        // Stop polling for terminal state
        if (this.orderPollTimeoutId) {
          clearTimeout(this.orderPollTimeoutId);
          this.orderPollTimeoutId = null;
        }
      } else if (order.status === "failed") {
        this.promptMessage =
          "Order failed. Please try again or contact support.";
        // Stop polling for terminal state
        if (this.orderPollTimeoutId) {
          clearTimeout(this.orderPollTimeoutId);
          this.orderPollTimeoutId = null;
        }
      } else {
        // Default case for unexpected statuses
        this.promptMessage = `Order status: ${order.status}. Please check your order history.`;
      }

      // Parse cartOrderIds from order with safe error handling
      let cartOrderIds = [];
      try {
        cartOrderIds = JSON.parse(order.cartOrderIds);
        if (!Array.isArray(cartOrderIds)) {
          cartOrderIds = [];
        }
      } catch (parseError) {
        console.warn(
          "Failed to parse cartOrderIds, defaulting to empty array:",
          parseError
        );
        cartOrderIds = [];
      }

      // Determine cafeId with fallback
      const effectiveCafeId = cafeId || order.cafeId;

      // Fetch cart details and order history
      if (effectiveCafeId && cartOrderIds.length > 0) {
        await this.getCartOrders(order.userId, effectiveCafeId, cartOrderIds);
        await this.getOrders(order.userId, effectiveCafeId, cartOrderIds);
      } else {
        // No cafeId found or no cart orders
        if (!effectiveCafeId) {
          console.warn("No cafeId available, setting empty cart");
        }
        this.cartOrders = [];
        this.orders = [];
      }
    } catch (error) {
      console.error("Failed to fetch order:", error);
      this.promptMessage = "Failed to load order. Please contact support.";
      this.presentAlert(500);
      return;
    }
  },
});
</script>
<style scoped>
.mb-img {
  margin-top: 10%;
  margin-bottom: -5px;
}
.dblock {
  display: block;
}
.orderstatus-div {
  background: #ffffff;
  border: 1px solid #f3f3f3;
  box-shadow: 0px 12px 18px rgba(0, 0, 0, 0.04);
  border-radius: 8px;
  padding-top: 5%;
  padding-bottom: 5%;
}
.row-orderlist {
  padding-left: 7%;
  padding-right: 7%;
}
.orderstatus-h1 {
  font-family: "Gilroy";
  font-style: normal;
  font-weight: 600;
  font-size: 18px;
  line-height: 21px;
  color: #1b1b1b;
}
.orderstatus-cancel {
  font-family: "Gilroy";
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 140%;
  text-align: right;
  color: #f04a3f;
}
.orderstatus-notify {
  font-family: "Gilroy";
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 140%;
  text-align: right;
  color: #00bf60;
}
.notify-icon {
  vertical-align: middle;
  padding-right: 5px;
  width: 16px;
}
.order-status {
  padding: 5%;
}
.txtlight-sml {
  font-family: "Gilroy";
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 140%;
  color: #828282;
}
.order-status-txtlight {
  font-family: "Gilroy";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  color: #828282;
  padding: 0 10px;
  white-space: nowrap;
}
.variation-category {
  font-weight: 400;
  color: #828282;
  text-transform: capitalize;
}
.variation-value {
  font-weight: 600;
  color: #1b1b1b;
}
.order-status-bold {
  font-family: "Gilroy";
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 140%;
  color: #1b1b1b;
}
.order-status-normal {
  font-family: "Gilroy";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 140%;
  color: #1b1b1b;
}
.position-right {
  position: absolute;
  right: 6px;
}
.dotsep-icon {
  vertical-align: middle;
  width: 3px;
  height: 3px;
  padding-right: 10px;
  padding-left: 5px;
}
.hr-subtotal {
  border-top: 1px solid #f3f3f3;
  margin-top: 20px;
  padding-top: 20px;
}
.orderstatus-maps {
  padding: 0%;
  border-radius: 8px;
  margin-top: 16px;
  margin-bottom: 16px;
  height: 185px;
}
ion-button {
  --background: #ffffff;
  --background-hover: #dce8ff;
  --background-activated: #dce8ff;
  --background-focused: #dce8ff;
  --color: #1b1b1b;
  --border-radius: 4px;
  --border-color: #f3f3f3;
  --border-style: solid;
  --border-width: 1px;
  --ripple-color: #dce8ff;
  margin-top: 16px;
  height: 52px;
  text-transform: none;
  --box-shadow: none;
}
.orderstatus-btn {
  font-family: "Gilroy";
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 19px;
  text-align: center;
  color: #ffffff;
}
.support-link a {
  font-family: "Gilroy";
  font-style: normal;
  font-weight: 600;
  font-size: 12px;
  line-height: 140%;
  text-align: center;
  color: #f87e63;
  text-decoration: none;
}
</style>
